export default {
  Bottom: 0,
  //     Represents center text alignment.
  Center: 1,
  //     Represents center across text alignment.
  CenterAcross: 2,
  //     Represents distributed text alignment.
  Distributed: 3,
  //     Represents fill text alignment.
  Fill: 4,
  //     Represents general text alignment.
  General: 5,
  //     Represents justify text alignment.
  Justify: 6,
  //     Represents left text alignment.
  Left: 7,
  //     Represents right text alignment.
  Right: 8,
  //     Represents top text alignment.
  Top: 9,
  //     Aligns the text with an adjusted kashida length for Arabic text.
  JustifiedLow: 10,
  //     Distributes Thai text specially, because each character is treated as a word.
  ThaiDistributed: 11
}
